import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore, increment } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAeVExbWgP9kffT4LUCDm3FPiCb9YSkc3Q",
  authDomain: "hostelchic-15e5e.firebaseapp.com",
  projectId: "hostelchic-15e5e",
  storageBucket: "hostelchic-15e5e.firebasestorage.app",
  messagingSenderId: "237288150136",
  appId: "1:237288150136:web:11393a72bd2f404237098d"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
export { increment };